<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
      <b-radio
        class="app-radio"
        v-for="item in items"
        :key="optionValue(item)"
        v-bind="$attrs"
        :value="value"
        :native-value="optionValue(item)"
        :id="forId"
        :size="size"
        expanded
        :disabled="loading"
        :placeholder="placeholder"
        @input="handleInput"
        @focus="$emit('focus', $event)"
        @blur="$emit('blur', $event)"
      >
        {{optionLabel(item)}}

        <template v-if="isItemValueHelpParam">
          <a :href="helpUrl + optionValue(item)" target="_blank" v-if="helpUrl && helpUrlText">{{ helpUrlText }}</a>
        </template>
        <template v-else>
          <a :href="helpUrl" target="_blank" v-if="helpUrl && helpUrlText">{{ helpUrlText }}</a>
        </template>
      </b-radio>
  </form-field>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormFieldRadio",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      items: {
        type: Array,
        default: () => []
      },
      value: {},
      placeholder: {
        type: String
      },
      optionLabel: {
        type: Function,
        default: (item) => item
      },
      optionValue: {
        type: Function,
        default: (item) => item
      },
      label: {
        type: String,
      },
      validationErrors: {
        type: [String, Array, undefined],
      },
      helpText: {
        type: String
      },
      helpUrl: {
        type: String
      },
      helpUrlText: {
        type: String
      },
      isItemValueHelpParam: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'is-small'
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        forId: this.$utils.generateClientId(),
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>

.app-radio {
  display: flex;
  width: 100%;
  margin-top: 0.5rem;

  a {
    margin-left: 5px;
  }
}
</style>
